<template>
  <div>
    <div
      v-if="isRouting"
      class="fixed inset-0 z-[10000] flex items-center justify-center bg-cream/90"
    >
      <LottieLoader :src="lottieJson" />
    </div>
    <router-view />
  </div>
</template>

<script>
import LottieLoader from "@/components/LottieLoader.vue";
import lottieJson from "@/assets/loader.json";

export default {
  name: "App",
  components: { LottieLoader },
  data() {
    return { isRouting: false, lottieJson };
  },
  mounted() {
    const onLoadEvt = (e) => {
      this.isRouting = !!(e && e.detail);
    };
    window.addEventListener("route-loading", onLoadEvt);
    this._onLoadEvt = onLoadEvt;
  },
  beforeUnmount() {
    if (this._onLoadEvt)
      window.removeEventListener("route-loading", this._onLoadEvt);
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}

.bg-cream {
  background-color: #fff7e8;
}
</style>
